export type Testimonial = {
  id: number;
  titleKey: string;
  textKey: string;
  authorKey: string;
};

export const testimonials: Testimonial[] = [
  {
    id: 1,
    titleKey: "testimonial_1_title",
    textKey: "testimonial_1_text",
    authorKey: "testimonial_1_author",
  },
  {
    id: 2,
    titleKey: "testimonial_2_title",
    textKey: "testimonial_2_text",
    authorKey: "testimonial_2_author",
  },
  {
    id: 3,
    titleKey: "testimonial_3_title",
    textKey: "testimonial_3_text",
    authorKey: "testimonial_3_author",
  },
  {
    id: 4,
    titleKey: "testimonial_4_title",
    textKey: "testimonial_4_text",
    authorKey: "testimonial_4_author",
  },
  {
    id: 5,
    titleKey: "testimonial_5_title",
    textKey: "testimonial_5_text",
    authorKey: "testimonial_5_author",
  },
  {
    id: 6,
    titleKey: "testimonial_6_title",
    textKey: "testimonial_6_text",
    authorKey: "testimonial_6_author",
  },
  {
    id: 7,
    titleKey: "testimonial_7_title",
    textKey: "testimonial_7_text",
    authorKey: "testimonial_7_author",
  },
];
